<template>
  <div
    :style="[
      $vuetify.breakpoint.xs ? { padding: '30px' } : { padding: '50px' },
    ]"
  >
    <div v-if="err">
      <h4 style="text-align: center">Debate room does not exist</h4>
    </div>
    <div id="root" v-else>
      <h4>Motion: {{ motion }}</h4>
      <img src="../assets/images/mic.png" height="150" style="margin: 20px 0" />
      <div class="container">
        <div
          class="input"
          :style="[
            $vuetify.breakpoint.xs ? { width: '100%' } : { width: '50%' },
          ]"
          v-if="
            gov.includes(userProfile.email) ||
            opp.includes(userProfile.email) ||
            teachers.includes(userProfile.email)
          "
        >
          <textarea
            v-model="arg"
            :placeholder="
              teachers.includes(userProfile.email)
                ? '<student>: <argument>'
                : gov.includes(userProfile.email)
                ? 'Argue for the motion'
                : 'Argue against the motion'
            "
          />
          <div
            :style="[
              teachers.includes(userProfile.email)
                ? {
                    display: 'flex',
                    'flex-direction': 'row',
                    'justify-content': 'space-between',
                  }
                : {},
            ]"
          >
            <div
              v-if="teachers.includes(userProfile.email)"
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 3px;
                margin-left: 3px;
              "
            >
              <input v-model="side" type="checkbox" />
              <div style="margin-left: 5px">Opposition</div>
            </div>
            <button
              class="btn btn-sm btn-outline-dark"
              style="float: right"
              @click="submit()"
            >
              Submit
            </button>
          </div>
        </div>
        <div v-else style="grid-column: 1 / span 2"></div>
        <div
          class="gov"
          :style="[
            $vuetify.breakpoint.xs ? { 'grid-column': '1/ span 2' } : {},
          ]"
        >
          Government
        </div>
        <div
          class="opp"
          :style="[
            $vuetify.breakpoint.xs
              ? { 'grid-column': '1/ span 2', 'grid-row': '5' }
              : { 'grid-column': '2' },
          ]"
        >
          Opposition
        </div>
        <div
          class="gova"
          v-if="govArgs.length"
          :style="[
            $vuetify.breakpoint.xs
              ? { 'grid-column': '1/ span 2', 'grid-row': '4' }
              : {},
          ]"
        >
          <div class="argbox" v-for="ar in govArgs" :key="ar.id">
            <div class="arg go">{{ ar.data.arg }}</div>
            <div style="display: flex; justify-content: space-between">
              <div
                style="
                  margin-left: 3%;
                  margin-top: 15px;
                  display: flex;
                  align-items: center;
                "
              >
                <img
                  :src="userData[ar.data.by].profilePicUrl"
                  width="30"
                  style="border-radius: 50%; object-fit: cover"
                />
                <span style="font-size: 11pt; margin-left: 7px"
                  >{{ userData[ar.data.by].name }} •
                  {{ ar.data.timestamp | fromNow }}</span
                >
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  margin-top: 15px;
                  margin-right: 5px;
                "
              >
                <span style="margin-right: 5px">{{
                  ar.data.likes.length
                }}</span>
                <b-icon-hand-thumbs-up
                  scale="1.2"
                  :style="[
                    ar.data.likes.includes(userProfile.email)
                      ? { color: 'lightgreen' }
                      : null,
                  ]"
                  :class="[
                    userProfile.email != ar.data.by ||
                    teachers.includes(userProfile.email)
                      ? 'ico'
                      : '',
                  ]"
                  @click="like(ar)"
                ></b-icon-hand-thumbs-up>
              </div>
            </div>
          </div>
        </div>
        <div
          class="oppa"
          v-if="oppArgs.length"
          :style="[
            $vuetify.breakpoint.xs
              ? { 'grid-column': '1/ span 2', 'grid-row': '6' }
              : { 'grid-column': '2' },
          ]"
        >
          <div class="argbox" v-for="ar in oppArgs" :key="ar.id">
            <div class="arg op">{{ ar.data.arg }}</div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                flex-direction: row-reverse;
              "
            >
              <div
                class="argdeets"
                style="
                  margin-right: 3%;
                  margin-top: 15px;
                  display: flex;
                  flex-direction: row-reverse;
                  align-items: center;
                "
              >
                <img
                  :src="userData[ar.data.by].profilePicUrl"
                  width="30"
                  style="border-radius: 50%; object-fit: cover"
                />
                <span style="font-size: 11pt; margin-right: 7px"
                  >{{ ar.data.timestamp | fromNow }} •
                  {{ userData[ar.data.by].name }}</span
                >
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  flex-direction: row-reverse;
                  margin-top: 15px;
                  margin-left: 5px;
                "
              >
                <span style="margin-left: 5px">{{ ar.data.likes.length }}</span>
                <b-icon-hand-thumbs-up
                  scale="1.2"
                  :style="[
                    ar.data.likes.includes(userProfile.email)
                      ? { color: 'lightgreen' }
                      : null,
                  ]"
                  :class="[
                    userProfile.email != ar.data.by ||
                    teachers.includes(userProfile.email)
                      ? 'ico'
                      : '',
                  ]"
                  @click="like(ar)"
                ></b-icon-hand-thumbs-up>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-direction: row-reverse;
            align-items: baseline;
            grid-column: 1 / span 2;
            grid-row: 2;
          "
        >
          <input
            type="checkbox"
            v-model="likeSort"
            @change="
              govArgs.sort(sort);
              oppArgs.sort(sort);
            "
          />
          <label style="margin-right: 5px">Sort by likes</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
const fb = require("../firebaseConfig");
export default {
  data() {
    return {
      motion: "",
      err: true,
      userData: {},
      gov: [],
      opp: [],
      arg: "",
      teachers: [],
      govArgs: [],
      oppArgs: [],
      likeSort: false,
      side: false,
    };
  },
  computed: {
    ...mapState(["userProfile"]),
  },
  created() {
    fb.db
      .doc(`debates/${this.$route.params.id}`)
      .get()
      .then((doc) => {
        if (doc.exists) {
          this.err = false;
          this.motion = doc.data().motion;
          this.userData = doc.data().userData;
          this.gov = doc.data().gov;
          this.opp = doc.data().opp;
          this.teachers = doc.data().teachers;
        }
      });
    fb.db
      .doc(`debates/${this.$route.params.id}`)
      .collection("govArgs")
      .orderBy("timestamp")
      .onSnapshot((qs) => {
        qs.docChanges().forEach((change) => {
          if (change.type == "added") {
            this.govArgs.unshift({
              data: change.doc.data(),
              id: change.doc.id,
            });
            this.govArgs.sort(this.sort);
          } else if (change.type == "modified") {
            this.govArgs.splice(
              this.govArgs.indexOf(
                this.govArgs.find((v) => v.id == change.doc.id)
              ),
              1
            );
            this.govArgs.unshift({
              data: change.doc.data(),
              id: change.doc.id,
            });
            this.govArgs.sort(this.sort);
          }
        });
      });
    fb.db
      .doc(`debates/${this.$route.params.id}`)
      .collection("oppArgs")
      .orderBy("timestamp")
      .onSnapshot((qs) => {
        qs.docChanges().forEach((change) => {
          if (change.type == "added") {
            this.oppArgs.unshift({
              data: change.doc.data(),
              id: change.doc.id,
            });
            this.oppArgs.sort(this.sort);
          } else if (change.type == "modified") {
            this.oppArgs.splice(
              this.oppArgs.indexOf(
                this.oppArgs.find((v) => v.id == change.doc.id)
              ),
              1
            );
            this.oppArgs.unshift({
              data: change.doc.data(),
              id: change.doc.id,
            });
            this.oppArgs.sort(this.sort);
          }
        });
      });
  },
  methods: {
    submit() {
      fb.db
        .doc(`debates/${this.$route.params.id}`)
        .collection(
          this.teachers.includes(this.userProfile.email)
            ? this.side
              ? "oppArgs"
              : "govArgs"
            : this.gov.includes(this.userProfile.email)
            ? "govArgs"
            : "oppArgs"
        )
        .add({
          arg: this.arg,
          by: this.userProfile.email,
          timestamp: fb.firebase.firestore.Timestamp.now(),
          likes: [],
        });
      this.arg = "";
    },
    sort(a, b) {
      if (this.likeSort) {
        if (a.data.likes.length > b.data.likes.length) return -1;
        if (a.data.likes.length < b.data.likes.length) return 1;
      }
      if (a.data.timestamp > b.data.timestamp) return -1;
      if (a.data.timestamp < b.data.timestamp) return 1;
      return 0;
    },
    like(arg) {
      if (arg.data.by == this.userProfile.email) {
        if (!this.teachers.includes(this.userProfile.email)) {
          return;
        }
      }
      if (arg.data.likes.includes(this.userProfile.email)) {
        fb.db
          .doc(`debates/${this.$route.params.id}`)
          .collection(this.govArgs.includes(arg) ? "govArgs" : "oppArgs")
          .doc(arg.id)
          .update({
            likes: fb.firebase.firestore.FieldValue.arrayRemove(
              this.userProfile.email
            ),
          });
      } else {
        fb.db
          .doc(`debates/${this.$route.params.id}`)
          .collection(this.govArgs.includes(arg) ? "govArgs" : "oppArgs")
          .doc(arg.id)
          .update({
            likes: fb.firebase.firestore.FieldValue.arrayUnion(
              this.userProfile.email
            ),
          });
      }
    },
  },
  filters: {
    fromNow(v) {
      return moment(v.toDate()).format("Do MMMM, h:mma");
    },
  },
};
</script>

<style scoped>
#root {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
}
.container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
.input {
  background-color: lightblue;
  grid-column: 1 / span 2;
  place-self: center;
  padding: 10px;
  border-radius: 5px;
}
.btn {
  height: 30px;
  font-size: 10pt;
}
textarea {
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 2px;
  width: 100%;
  padding: 4px 8px;
  resize: none;
}
.gov {
  background-color: lightgreen;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}
.opp {
  background-color: lightpink;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}
.gova,
.oppa {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 42vh;
  overflow-y: scroll;
}
.arg {
  padding: 10px 15px;
  border-radius: 5px;
  position: relative;
}
.arg:after {
  bottom: 0;
  left: 10%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-top-color: rgba(0, 0, 0, 0.05);
  border-bottom: 0;
  border-width: 8px;
  margin-left: -10px;
  margin-bottom: -8px;
}
.go {
  background-color: rgba(0, 0, 0, 0.05);
}
.go:after {
  border-left: 0;
}
.op {
  background: rgba(0, 0, 0, 0.05);
  margin-left: auto;
}
.op:after {
  border-top-color: rgba(0, 0, 0, 0.05);
  left: 93%;
  border-right: 0;
}
.ico:hover {
  color: lightgreen;
}
</style>